export default {
  init() {
    // JavaScript to be fired on all pages

    //Initalise all slick sliders
    var sliders = $('.slick-slider');
    sliders.each(function() {
      $(this).slick();
    });
  },
  
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js